<template>
  <div>
    <v-expand-transition v-if="filesToUpload.length">
      <AppFileManager @cancel="cancelAllFilesDialogIsOpen = true">
        <template #header>
          <div class="d-flex align-center">
            <font-awesome-icon v-if="noError"
                               :icon="['far', 'check']"
                               class="text-success mr-3"
                               style="font-size: 20px;"
            ></font-awesome-icon>
            <span v-t="{
              path: 'common.app-file-upload.AppFileUpload.title',
              plural: successFilders,
              args: { successCount: successFilders, totalCount: uploadQueue.length },
            }" />
          </div>
        </template>
        <template #content>
          <app-alert-in-page
            v-if="showWatermarkAlert"
            class="my-6"
            variant="info"
            :dismissible="false"
            :hasLeftBorder="false"
          >
            {{ $t('project.documents.Documents.watermarkInfos') }}
          </app-alert-in-page>
          <div class="AppFileUpload__fildersContainer">
            <template v-for="(filder, index) in filesToUpload" :key="`filder-${index}`">
              <component :is="filder.type === 'file' ? 'AppFileUploadFile' : 'AppFileUploadFolder'"
                         :file="filder"
                         :folder="filder"
              />
            </template>
          </div>
        </template>
      </AppFileManager>
    </v-expand-transition>
    <RoomStorageExceededDialog
      v-if="roomStorageExceededDialogIsOpen"
      @close="onRoomStorageExceededDialogClose"
    />
    <CancelAllFilesDialog v-if="cancelAllFilesDialogIsOpen"
                          @close="cancelAllFilesDialogIsOpen = false"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'

import RoomStorageExceededDialog from '@/common/app-file-upload/RoomStorageExceededDialog.vue'
import AppFileManager from '@/common/AppFileManager.vue'
import { SET_ROOM_STORAGE_EXCEEDED_DIALOG_IS_OPEN } from '@/store/modules/room/mutation_types'

import AppFileUploadFile from './AppFileUploadFile.vue'
import AppFileUploadFolder from './AppFileUploadFolder.vue'
import CancelAllFilesDialog from './CancelAllFilesDialog.vue'
import { uploadStatus } from './uploadStatus'

export default {
  name: 'AppFileUpload',
  components: {
    AppFileManager,
    AppFileUploadFile,
    AppFileUploadFolder,
    CancelAllFilesDialog,
    RoomStorageExceededDialog,
  },
  data () {
    return {
      cancelAllFilesDialogIsOpen: false,
    }
  },
  computed: {
    ...mapState('appUploadHandler', ['filesToUpload', 'uploadQueue']),
    ...mapState('room', ['roomStorageExceededDialogIsOpen', 'currentRoom']),
    successFilders () {
      return this.uploadQueue.filter(f => f.status === uploadStatus.SUCCESS).length
    },
    noError () {
      return this.uploadQueue.every(f => f.status === uploadStatus.SUCCESS || f.status === uploadStatus.CANCELED)
    },
    showWatermarkAlert () {
      return Boolean(this.currentRoom?.isDataroom && this.currentRoom?.watermarkEnabled)
    },
  },
  methods: {
    ...mapMutations('room', [SET_ROOM_STORAGE_EXCEEDED_DIALOG_IS_OPEN]),
    onRoomStorageExceededDialogClose () {
      this.SET_ROOM_STORAGE_EXCEEDED_DIALOG_IS_OPEN(false)
    },
  },
}
</script>

<style scoped lang="scss">
.AppFileUpload {
  &__fildersContainer {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
